import { PatientNoteDTO } from 'app/view/journal/data/PatientNoteDTO';
import { PatientNotePageCriteriaDTO } from 'app/view/journal/data/PatientNotePageCriteriaDTO';
import { PatientNoteCalendarRequestDTO } from 'app/view/journal/data/PatientNoteCalendarRequestDTO';

export namespace PatientDailyNotesActions {
  const prefix: string = '[PatientDailyNotes]';

  export class GetCurrentNote {
    static readonly type = `${prefix} Get current note`;

    constructor() {
    }
  }

  export class GetNotesPage {
    static readonly type = `${prefix} Get note page`;

    constructor(public criteria: PatientNotePageCriteriaDTO = new PatientNotePageCriteriaDTO()) {
    }
  }

  export class CreateNote {
    static readonly type = `${prefix} Create note`;

    constructor(public payload: PatientNoteDTO) {
    }
  }

  export class UpdateNote {
    static readonly type = `${prefix} Update note`;

    constructor(public payload: PatientNoteDTO) {
    }
  }

  export class DeleteNote {
    static readonly type = `${prefix} Delete note`;

    constructor(public noteId: number) {
    }
  }

  export class GetNoteById {
    static readonly type = `${prefix} Get note by id`;

    constructor(public noteId: number) {
    }
  }

  export class GetCalendarDays {
    static readonly type = `${prefix} Get calendar days`;

    constructor(public request: PatientNoteCalendarRequestDTO) {
    }
  }

  export class ClearState {
    static readonly type = `${prefix} Clear state`;

    constructor() {
    }
  }
} 